import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { contentAPI, settingsAPI } from '../services/api';

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [settings, setSettings] = useState({});
  const shouldFetchRemoteContent = process.env.REACT_APP_ENABLE_CMS === 'true';
  const [loading, setLoading] = useState(shouldFetchRemoteContent);

  const fetchData = useCallback(async () => {
    try {
      const [contentRes, settingsRes] = await Promise.all([
        contentAPI.getAll(),
        settingsAPI.getAll()
      ]);
      setContent(contentRes.data);
      setSettings(settingsRes.data);
    } catch (error) {
      console.error('Error fetching content:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (shouldFetchRemoteContent) {
      fetchData();
    }
  }, [fetchData, shouldFetchRemoteContent]);

  const updateContent = async (section, data) => {
    const response = await contentAPI.update(section, data);
    if (response.data.success) {
      setContent(prev => ({ ...prev, [section]: response.data.data }));
    }
    return response.data;
  };

  const updateSetting = async (key, value) => {
    const response = await settingsAPI.update(key, value);
    if (response.data.success) {
      setSettings(prev => ({ ...prev, [key]: value }));
    }
    return response.data;
  };

  return (
    <ContentContext.Provider value={{ content, settings, loading, updateContent, updateSetting, fetchData }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const context = useContext(ContentContext);
  if (!context) {
    throw new Error('useContent must be used within a ContentProvider');
  }
  return context;
};
